import React, {useEffect, useState} from 'react'
import { CadViewer } from '@cadview/react';
import { findFile } from "../../../../Fetch/GetPDF";
export default function CadView(props) {

const [data, setData] = useState([])

    useEffect(() => {
     
     findFile(props.hash, props.id).then(res => {
                if (res.valid) {
                    if (res.payload.length > 0) {
                       setData(                       
                            res.payload
                       )
                    }
                }
            })
     
    }, [props])
    
  function dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[arr.length - 1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }

  return (
    <div> {
        data.map((el,ind)=>(
            <CadViewer key={ind} file={dataURLtoFile(`data:;base64,${el.file}`, 'cosa.dxf')} theme="dark" style={{ width: '100%', height: '500px' }} />
        ))
        /* <CadViewer file={dataURLtoFile(`data:;base64,${props.data.file}`, 'cosa.dxf')} theme="dark" tool="measure" style={{ width: '100%', height: '500px' }} /> */
        }</div>
  )
}
